import React from 'react';
import {connect} from 'react-redux';
import {Field, reduxForm} from 'redux-form';

import Button from 'components/Button';
import ErrorBlock from 'components/ErrorBlock';
import {ExpandingTextAreaField} from 'components/Fields';

import './styles.css';

const formSubmit = (values, _dispatch, props) => {
  const {text} = values;

  props.submitAction({noteText: text});
};

class AddNoteForm extends React.Component<any> {
  triggerSubmit = () => {
    this.props.submit(this.props.formName);
  };

  onKeyDown = event => {
    const {submitting} = this.props;

    // textarea does not have keyCode property onChange, that's why we do this
    // onkeyDown and exclude shift + enter
    if (
      event.keyCode === 13 &&
      event.shiftKey === false &&
      submitting === false
    ) {
      event.preventDefault();
      this.triggerSubmit();
    }
  };

  clodRoomNoteForm = this.props.closeForm;

  render() {
    const {error, submitting, handleSubmit} = this.props;

    return (
      <form className="AddNoteForm" onSubmit={handleSubmit}>
        {error && <ErrorBlock>{error}</ErrorBlock>}

        <Field
          name="text"
          className="addRoomNoteTextArea"
          component={ExpandingTextAreaField}
          placeholder="Add note..."
          minHeight="6rem"
          maxHeight="10rem"
          onKeyDown={this.onKeyDown}
        />
        <div className="buttons">
          <Button
            white
            className="cancelButton"
            type="button"
            onClick={this.clodRoomNoteForm}>
            Cancel
          </Button>
          <Button
            className="addRoomNoteButton"
            onClick={this.triggerSubmit}
            blue={!submitting}
            isLoading={submitting}
            disabled={submitting}>
            Done
          </Button>
        </div>
      </form>
    );
  }
}

const mapStateToProps = (_state, props) => ({
  form: props.formName
});

const addNoteForm = reduxForm({
  onSubmit: formSubmit
})(AddNoteForm);

export default connect(mapStateToProps)(addNoteForm);
